import { ICurrency, IProfessionHobby, IProfessionSkill, IProfessionSubject, ITutorCalenderSlot, ITutorEducationDetails, ITutorExperienceDetails, ITutorPersonalDetails, ITutorProfessionDetails, ITutorStatus } from "@wot/typings";
import { LOCAL_URl } from ".";

const getById = async (id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile?id=${id}`)
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const getByAccountId = async (id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile?id=${id}`)
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updateCalender = async (id: string, calender: ITutorCalenderSlot[]) => {
  return await fetch(`${LOCAL_URl}/t/calender`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ _id: id, data: { calender } })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

export type PUdateProfile = {
  personal?: ITutorPersonalDetails
  education?: ITutorEducationDetails,
  experience?: ITutorExperienceDetails,
  profession?: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>,
  status?: ITutorStatus,
  prefrences?: {
    lessonUpdates: boolean;
    accountUpdates: boolean;
    currency: ICurrency;
    timezone: string;
  }
}
const updateProfile = async (id: string, data: PUdateProfile) => {
  console.log(data);
  return await fetch(`${LOCAL_URl}/t/profile`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      _id: id, data
    })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const tutorProfileApi = {
  getById,
  updateCalender,
  getByAccountId,
  updateProfile
}

export default tutorProfileApi;